import { defineStore } from 'pinia'
import { apiTaskList } from '@/api/task'
import { formatTime } from '@/common/utils'

export const useGenerationHistoryStore = defineStore('generationHistory', {
  state: () => ({
    isLoading: false,
    taskList: [],
    pageIndex: 1, // 这个接口的分页页码是从 1 开始
    hasMore: true,
  }),
  getters: {},
  actions: {
    async fetchTaskList() {
      return new Promise<any>((resolve, reject) => {
        if (this.isLoading || !this.hasMore) {
          return
        }
        this.isLoading = true
        apiTaskList({ page: this.pageIndex, page_size: 20 })
          .then((data) => {
            if (this.pageIndex == 1) {
              this.taskList = []
            }
            let task_list = []
            for (let item of data.tasks) {
              item.create_at = formatTime(item.create_at * 1000, 2)
              task_list.push(item)
            }
            if (task_list.length > 0) {
              this.taskList.push(...task_list)
            }
            this.pageIndex++
            this.hasMore = this.taskList.length < data.total
            resolve(task_list)
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      })
    },
    async refreshTaskList() {
      this.clearData()
      this.fetchTaskList()
    },
    clearData() {
      this.isLoading = false
      this.taskList = []
      this.pageIndex = 1
      this.hasMore = true
    },
  },
})
